import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import { iconsSet as faIcons } from './assets/icons/fa-icons.js'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import BootstrapVue, {ToastPlugin} from 'bootstrap-vue'
import Vuex from 'vuex'
import moment from 'moment'
import Amplify, * as AmplifyModules from "aws-amplify";
import { AmplifyPlugin } from "aws-amplify-vue";
import awsmobile from "@/auth/aws-exports";
import VueSignaturePad from 'vue-signature-pad';

Amplify.configure(awsmobile);
Vue.use(AmplifyPlugin, AmplifyModules);

library.add(faIcons)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.performance = true
Vue.use(CoreuiVue)

Vue.use(BootstrapVue);
Vue.use(ToastPlugin);
Vue.use(Vuex);
Vue.use(require('vue-faker'));
Vue.use(require('vue-moment'));
Vue.prototype.moment = moment;
Vue.use(require('vue-top-progress'));
Vue.use(VueSignaturePad);

new Vue({
  el: '#app',
  router,
  store,
  icons,
  template: '<App/>',
  components: {
    App
  },
  created() {
    // this.default_moment_formats = {
    //   datetime: 'MMMM D YYYY, h:mm:ss a',
    //   date: 'MMMM D YYYY',
    //   time: 'h:mm:ss a',
    // };
  }
})
